const fileDownloadButtonTreeNode = {
  title: 'Generate qrcode for this branch',
  cutOut: 'Cut',
  paste: 'Paste'
};

export default fileDownloadButtonTreeNode;
